import React, { useEffect, useState } from 'react'
import JobCard from './JobCard'
import ReactPaginate from 'react-paginate'
import axios from 'axios'
import { hrmJobPort } from '../../App'
import { useNavigate } from 'react-router-dom'
import RightSideBlog from '../RightSideBlog'
import { motion } from 'framer-motion'
import { Filter } from 'lucide-react'

const JobSection = ({ jobs }) => {
    let [data, setdata] = useState()
    let navigate = useNavigate()
    const [itemOffset, setItemOffset] = useState(0);
    const [currentItems, setcurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const itemsPerPage = 5;
    
    useEffect(() => {
        if (data) {
            const endOffset = itemOffset + itemsPerPage;
            setcurrentItems(data.slice(itemOffset, endOffset));
            setPageCount(Math.ceil(data.length / itemsPerPage));
        }
    }, [itemOffset, data])
    
    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % (data?.length || 1);
        setItemOffset(newOffset);
        document.getElementById('jobsSection')?.scrollIntoView({ behavior: 'smooth' })
    };

    let getJob = () => {
        axios.get(`${hrmJobPort}/api/job_description/?active_only=true`).then((response) => {
            console.log(response.data);
        }).catch((error) => {
            console.log(error);
        })
    }
    
    useEffect(() => {
        getJob()
        if (jobs) {
            setdata(jobs)
            setItemOffset(0) // Reset pagination when filter changes
        }
    }, [jobs])

    return (
        <div className='bg-white py-16' id='jobsSection' >
            <main className='container mx-auto px-6 poppins' >
                <div className='flex flex-col lg:flex-row gap-10' >
                    {/* Main Job List */}
                    <article className='lg:w-2/3' >
                        <section className='flex justify-between items-end border-b border-slate-200 pb-4 mb-8' >
                            <div>
                                <h3 className='text-3xl font-bold text-slate-900'>Latest Openings</h3>
                                <p className='text-slate-500 mt-2'>{data ? data.length : 0} Jobs Available</p>
                            </div>
                            
                            {/* Optional Filter Button placeholder */}
                            <button className="hidden md:flex items-center gap-2 text-slate-600 bg-slate-100 hover:bg-slate-200 px-4 py-2 rounded-lg font-medium transition-colors">
                                <Filter size={18} />
                                Filter
                            </button>
                        </section>

                        {/* Jobs */}
                        <div className='space-y-4' >
                            {
                                currentItems && currentItems.map((obj, index) => (
                                    <motion.div 
                                        initial={{ opacity: 0, y: 10 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.3, delay: index * 0.05 }}
                                        key={obj.id || index} 
                                        onClick={() => navigate(`/jobs/${obj.slug || obj.id}`)}
                                        className='cursor-pointer' 
                                    >
                                        <JobCard data={obj} />
                                    </motion.div>
                                ))
                            }
                            
                            {(!currentItems || currentItems.length === 0) && (
                                <div className="text-center py-20 bg-slate-50 rounded-2xl border border-dashed border-slate-300">
                                    <p className="text-slate-500 font-medium">No jobs found matching your criteria.</p>
                                </div>
                            )}

                            {pageCount > 1 && (
                                <div className="mt-12 flex justify-center">
                                    <ReactPaginate
                                        breakLabel="..."
                                        onPageChange={handlePageClick}
                                        pageRangeDisplayed={2}
                                        marginPagesDisplayed={1}
                                        pageCount={pageCount}
                                        containerClassName='flex gap-2 items-center'
                                        pageLinkClassName='w-10 h-10 flex items-center justify-center rounded-lg border border-slate-200 text-slate-600 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 transition-colors font-medium'
                                        previousLinkClassName='px-4 h-10 flex items-center justify-center rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors font-medium'
                                        nextLinkClassName='px-4 h-10 flex items-center justify-center rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors font-medium'
                                        activeLinkClassName='!bg-blue-600 !text-white !border-blue-600'
                                        disabledClassName='opacity-50 cursor-not-allowed'
                                    />
                                </div>
                            )}
                        </div>
                    </article>

                    {/* Right Side Sidebar */}
                    <aside className='lg:w-1/3' >
                        <div className="sticky top-24">
                            <RightSideBlog />
                        </div>
                    </aside>
                </div>
            </main>
        </div>
    )
}

export default JobSection